// extracted by mini-css-extract-plugin
export default {"eventInfo":"TldzROyiCF","title":"eQDRBN_hqB","kbd":"pwiw4y3RYy","boolean":"zO3mK4c7iw","false":"IDdTEbH8Jy","deprecation":"RfjmHJl0FT","space":"gXcn9i6VOd","dark":"UjryMWopDT"};